import gql from 'graphql-tag'

export default gql`
mutation cancelAppointment(
  $id: ID!
  $token: String
  $cancelFutureOccurrences: Boolean
  $occurrenceDate: DateTime
) {
  cancelAppointment(
    id: $id
    token: $token
    cancelFutureOccurrences: $cancelFutureOccurrences
    occurrenceDate: $occurrenceDate
  ) {
    id
  }
}
`
